module.exports = __webpack_public_path__ + "img/logo.2c4baa3d.png";